import { useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

import { useAuth, ROLE_META, ALL_VALID_ROLES, type Role } from "../auth/AuthContext";
import { Icon } from "../components/Icon";

export function LoginView(): JSX.Element {
  const { user, login, isLoading, isDemo, setDemoRole, activeRole } = useAuth();
  const location = useLocation();
  const [selected, setSelected] = useState<Role>(activeRole ?? "Gerente");

  if (isLoading) {
    return (
      <div className="auth-shell">
        <div className="auth-card">
          <div className="auth-card__brand">
            <Icon name="droplet" size={28} />
          </div>
          <h1 style={{ marginBottom: 6 }}>Plataforma Analítica Sanitaria</h1>
          <p className="text-muted">Cargando sesión…</p>
        </div>
      </div>
    );
  }

  if (user) {
    const from = (location.state as { from?: string } | null)?.from ?? "/";
    return <Navigate to={from} replace />;
  }

  return (
    <div className="auth-shell">
      <div className="auth-card">
        <div className="auth-card__brand">
          <Icon name="droplet" size={28} />
        </div>
        <h1 style={{ marginBottom: 6 }}>Plataforma Analítica Sanitaria</h1>
        <p className="text-muted" style={{ marginBottom: 24 }}>
          {isDemo
            ? "Estás en modo demo. Elige el perfil con el que quieres ingresar; cada uno ve su propia consola."
            : "Inicia sesión con tus credenciales corporativas para continuar."}
        </p>

        {isDemo && (
          <div className="form-field" style={{ marginBottom: 20, textAlign: "left" }}>
            <span>Perfil de acceso</span>
            <select
              aria-label="Perfil de acceso"
              value={selected}
              onChange={(e) => setSelected(e.target.value as Role)}
            >
              {ALL_VALID_ROLES.map((r) => (
                <option key={r} value={r}>
                  {ROLE_META[r].label}
                </option>
              ))}
            </select>
            <p className="text-muted" style={{ fontSize: 12, marginTop: 6 }}>
              {ROLE_META[selected].description}
            </p>
          </div>
        )}

        <button
          type="button"
          className="btn btn--primary btn--lg"
          onClick={() => {
            if (isDemo) setDemoRole(selected);
            void login();
          }}
        >
          {isDemo ? `Entrar como ${ROLE_META[selected].label}` : "Iniciar sesión con SSO"}
        </button>
        {isDemo && (
          <p className="text-muted" style={{ marginTop: 24, fontSize: 12.5 }}>
            Podrás cambiar de perfil en cualquier momento desde el selector
            de la barra superior.
          </p>
        )}
      </div>
    </div>
  );
}
